import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './components/NavBar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setFadeIn(false);
    const timer = requestAnimationFrame(() => setFadeIn(true));
    return () => cancelAnimationFrame(timer);
  }, [pathname]);

  return (
    <div>
      <Navbar />
      <div className={`content page-transition ${fadeIn ? 'page-visible' : ''}`}>{children}</div>
    </div>
  );
};

export default Layout;
